module.exports = __webpack_public_path__ + "media/flags/lu-9f59bed1.svg";